import { defineMessages } from 'react-intl-next';
export var messages = defineMessages({
  chromeCollapsedPlaceholder: {
    id: 'fabric.editor.chromeCollapsedPlaceholder',
    defaultMessage: 'Type something…',
    description: 'placeholder for an input where users insert text'
  }
});